import axios from "axios";
import { URL_HOST, TIME_LOGIN } from "const/CommonConst";

const CURRENT_SERVICE = `${URL_HOST}Usuario`;

const UserService = {
  authenticate: async (username,password) => {
    try {
      const { data } = await axios({
        url:  `${CURRENT_SERVICE}/Authenticate`,
        method: 'post',
        data: {
          "username": username,
          "password": password
        },
       // timeout: TIME_LOGIN
      });

      return data;
    } catch (error) {
      console.error(error.message);

      throw error;
    }
  },  
  refreshToken: async (accessToken,refreshToken) => {
    try {
      // const result = await axios.get(
      //     `${CURRENT_SERVICE}/GetByCode?code=${code}`);
      return true; // result.data;
    } catch (error) {
      console.error(error.message);

      throw error;
    }
  },  
//   add: async (record) => {
//     try {
//       if (!record || record.id !== 0) return false;

//       const { data } = await axios.post(
//         `${CURRENT_SERVICE}/Add`,
//         {
//             ...record,
//         }
//       );
//       return data;
//     } catch (error) {
//       console.error(error.message);

//       throw error;
//     }
//   },
//   update: async (record) => {
//     try {
//       if (!record || record.id === 0) return false;

//       const { data } = await axios.put(
//         `${CURRENT_SERVICE}/Update`,
//         {
//           ...record
//         }
//       );
//       return data;
//     } catch (error) {
//       console.error(error.message);

//       return false;
//     }
//   },
//   delete: async (id) => {
//     try {
//       if (id === 0) return false;

//       const { data } = await axios.delete(`${CURRENT_SERVICE}/Delete?id=${id}` );
//       return data;
//     } catch (error) {
//       console.error(error.message);

//       return false;
//     }
//   }
};

export default UserService;
